import React from 'react';

export default function SvgSessionsIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.94825 3.1121C5.08392 3.0363 5.23734 2.99801 5.39272 3.00116C5.5481 3.0043 5.69984 3.04878 5.83233 3.13001L7.66477 4.25478C7.79217 4.33306 7.89738 4.44269 7.97037 4.5732C8.04335 4.70371 8.08167 4.85074 8.08167 5.00028C8.08167 5.14981 8.04335 5.29684 7.97037 5.42735C7.89738 5.55786 7.79217 5.66749 7.66477 5.74578L5.83233 6.87104C5.69967 6.95238 5.54772 6.99686 5.39213 6.99991C5.23655 7.00295 5.08297 6.96445 4.94723 6.88838C4.81148 6.8123 4.69848 6.7014 4.61987 6.56711C4.54132 6.43293 4.49995 6.28025 4.5 6.12477C4.5 6.12472 4.5 6.12466 4.5 6.12461L4.5 3.87434C4.50029 3.71893 4.54197 3.5664 4.62075 3.43243C4.69953 3.29847 4.81257 3.1879 4.94825 3.1121ZM5.5 4.09937L6.96776 5.0003L5.5 5.90163V4.09937Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 10.5C3 10.2239 3.22386 10 3.5 10H8.5C8.77614 10 9 10.2239 9 10.5C9 10.7761 8.77614 11 8.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 2C1.72386 2 1.5 2.22386 1.5 2.5V7.5C1.5 7.77614 1.72386 8 2 8H10C10.2761 8 10.5 7.77614 10.5 7.5V2.5C10.5 2.22386 10.2761 2 10 2H2ZM0.5 2.5C0.5 1.67157 1.17157 1 2 1H10C10.8284 1 11.5 1.67157 11.5 2.5V7.5C11.5 8.32843 10.8284 9 10 9H2C1.17157 9 0.5 8.32843 0.5 7.5V2.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
